import BhiIcon from 'assets/Programs/BHI.svg';
import CardiologyIcon from 'assets/Programs/Cardiology.svg';
import CcmIcon from 'assets/Programs/CCM.svg';
import GuideIcon from 'assets/Programs/GUIDE.svg';
import HomeCareIcon from 'assets/Programs/Home care.svg';
import HomeHealthIcon from 'assets/Programs/Home Health.svg';
import HospiceIcon from 'assets/Programs/Hospice.svg';
import MemoryConnectIcon from 'assets/Programs/MC.svg';
import NeurologyIcon from 'assets/Programs/Neurology.svg';
import PalliativeIcon from 'assets/Programs/Palliative.svg';
import PartBIcon from 'assets/Programs/Part B.svg';
import PcpIcon from 'assets/Programs/PCP.svg';
import PharmacyIcon from 'assets/Programs/Pharmacy.svg';
import PrnIcon from 'assets/Programs/PRN1.svg';
import PsychIcon from 'assets/Programs/Psych.svg';
import RpmIcon from 'assets/Programs/RPM.svg';
import SnfIcon from 'assets/Programs/SNF Resident.svg';
import TcmIcon from 'assets/Programs/TCM.svg';
import MoveInReportIcon from 'assets/Programs/Move In Report.svg';
import WellnessAtRiskIcon from 'assets/Programs/Wellness At Risk.svg';
import ConciergeIcon from 'assets/Programs/Concierge.svg';
import PartnerIcon from 'assets/Programs/Partner.svg';
import OneTimeIcon from 'assets/Programs/One Time.svg';
import LostPatientIcon from 'assets/Programs/Lost Patient.svg';
import CareAtHomeIcon from 'assets/Programs/Care at Home_light.svg';
import HnAcoReach from 'assets/Programs/HnAcoReach.svg';
import CareMoreIcon from 'assets/Programs/CareMore.svg';
import OptumMAIcon from 'assets/Programs/OptumMA.svg';
import OptumCareAtHomeIcon from 'assets/Programs/OptumCareAtHome.svg';
import { ProgramName } from '@common/types';

const ProgramIcons: Record<ProgramName, string> = {
  [ProgramName.MOVE_IN_REPORT]: MoveInReportIcon,
  [ProgramName.BHI]: BhiIcon,
  [ProgramName.CARDIOLOGY]: CardiologyIcon,
  [ProgramName.CCM]: CcmIcon,
  [ProgramName.GUIDE]: GuideIcon,
  [ProgramName.HOME_CARE]: HomeCareIcon,
  [ProgramName.HOME_HEALTH]: HomeHealthIcon,
  [ProgramName.HOSPICE]: HospiceIcon,
  [ProgramName.MEMORY_CONNECT]: MemoryConnectIcon,
  [ProgramName.NEUROLOGY]: NeurologyIcon,
  [ProgramName.PALLIATIVE]: PalliativeIcon,
  [ProgramName.PART_B]: PartBIcon,
  [ProgramName.PCP]: PcpIcon,
  [ProgramName.PHARMACY]: PharmacyIcon,
  [ProgramName.PRN]: PrnIcon,
  [ProgramName.PSYCH]: PsychIcon,
  [ProgramName.RPM]: RpmIcon,
  [ProgramName.SNF]: SnfIcon,
  [ProgramName.TCM]: TcmIcon,
  [ProgramName.WELLNESS]: WellnessAtRiskIcon,
  [ProgramName.WELLNESS_AT_RISK]: WellnessAtRiskIcon,
  [ProgramName.CONCIERGE]: ConciergeIcon,
  [ProgramName.PARTNER]: PartnerIcon,
  [ProgramName.ONE_TIME]: OneTimeIcon,
  [ProgramName.LOST_PATIENT]: LostPatientIcon,
  [ProgramName.HN_ACO_REACH]: HnAcoReach,
  [ProgramName.CARE_AT_HOME]: CareAtHomeIcon,
  [ProgramName.CARE_MORE]: CareMoreIcon,
  [ProgramName.OPTUM_MA]: OptumMAIcon,
  [ProgramName.OPTUM_CARE_AT_HOME]: OptumCareAtHomeIcon,
};

export const ProgramIcon = ({
  program,
  size = 32,
  disabled = false,
}: {
  program: ProgramName;
  size?: number;
  disabled?: boolean;
}) => {
  const IconComponent = ProgramIcons[program];
  if (!IconComponent) return null;
  return (
    <img
      src={IconComponent}
      style={{
        objectFit: 'cover',
        height: size,
        width: size,
        filter: disabled ? 'grayscale(100%)' : undefined,
        opacity: disabled ? 0.4 : 1,
      }}
      alt={IconComponent}
    />
  );
};
